/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Room_DescInputs */

const en_mk_nav_room_desc = /** @type {(inputs: Mk_Nav_Room_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Align your team on problems and ideas.`)
};

const id_mk_nav_room_desc = /** @type {(inputs: Mk_Nav_Room_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepakati masalah dan ide bersama tim.`)
};

/**
* | output |
* | --- |
* | "Align your team on problems and ideas." |
*
* @param {Mk_Nav_Room_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_room_desc = /** @type {((inputs?: Mk_Nav_Room_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Room_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_room_desc(inputs)
	return en_mk_nav_room_desc(inputs)
});